import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '3393692204131283';
// Meta Conversions API Access Token (for server-side event tracking)
const CAPI_TOKEN = 'EAALGZANUbZCooBQwzbB3oio2m6j58jB6EyVWDi10y4mqvhaznrxvG0YBU1zXT9QkZBoot2UXhzXOarrCt8iqZCj6JtaLmgSCUu3lB6YReEmRZAki6ipUEu84iO7VGnsKQ4k39DzbX85T32ppgNZCnyv5ZB6aUDlXoSZA3IP0godl5M41pcZADavUrf26S0XClFze2jQZDZD';
export function initPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const f: any = window;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
}
export function MetaPixel() {
  useEffect(() => {
    initPixel();
  }, []);
  return <noscript data-id="element-12">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-13" />
    </noscript>;
}